'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _mobxReact = require('mobx-react');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

function createDisabledContainer(WrappedComponent) {
  var _class, _class2, _temp;

  var DisabledContainer = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
    _inherits(DisabledContainer, _Component);

    function DisabledContainer() {
      _classCallCheck(this, DisabledContainer);

      return _possibleConstructorReturn(this, (DisabledContainer.__proto__ || Object.getPrototypeOf(DisabledContainer)).apply(this, arguments));
    }

    _createClass(DisabledContainer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        _reactTooltip2.default.rebuild();
      }
    }, {
      key: 'render',
      value: function render() {
        var classNames = (0, _classnames2.default)(this.props.className, 'disabled');

        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
          className: classNames,
          'data-for': 'permission-required',
          'data-tip': true,
          'data-tip-disable': false,
          onClick: null,
          onSelect: null
        }));
      }
    }, {
      key: '__reactstandin__regenerateByEval',
      // @ts-ignore
      value: function __reactstandin__regenerateByEval(key, code) {
        // @ts-ignore
        this[key] = eval(code);
      }
    }]);

    return DisabledContainer;
  }(_react.Component), _class2.displayName = 'DisabledContainer(' + (0, _recompose.getDisplayName)(WrappedComponent) + ')', _class2.propTypes = {
    className: _propTypes2.default.any
  }, _temp)) || _class;

  return DisabledContainer;
}

var _default = createDisabledContainer;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(createDisabledContainer, 'createDisabledContainer', '/app/src/containers/DisabledContainer.js');
  reactHotLoader.register(_default, 'default', '/app/src/containers/DisabledContainer.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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